<svg 
    version="1.1" 
    xmlns="https://www.w3.org/2000/svg" 
    xmlns:xlink="https://www.w3.org/1999/xlink" 
    width="1024" 
    height="1024" 
    viewBox="0 0 1024 1024"
>
	<path d="M574.822 92.16c-227.635 0-412.723 182.374-418.253 409.344h-125.85l188.365 209.971 188.314-209.971h-146.227c5.53-169.011 143.77-304.384 313.651-304.384 173.363 0 313.856 140.954 313.856 314.88s-140.493 314.88-313.856 314.88c-69.53 0-133.734-22.733-185.754-61.082l-71.987 77.005c71.066 55.757 160.512 89.037 257.741 89.037 231.117 0 418.509-187.955 418.509-419.84-0.051-231.885-187.443-419.84-418.509-419.84zM537.6 286.72v240.128l153.856 153.856 50.688-50.688-132.864-132.864v-210.432h-71.68z" />
</svg>
